import script from "./productCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./productCenter.vue?vue&type=script&setup=true&lang=js"

import "./productCenter.vue?vue&type=style&index=0&id=de120350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de120350"]])

export default __exports__